import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IccEligibleProviderImportsService } from 'app/core/services/icc/icc-eligible-provider-imports.service';
import { ImportUploadResult, IccImportUploadComponent } from '../../components/icc-import-upload/icc-import-upload.component';
import { HttpErrorResponse } from '@angular/common/http';
import { isEmpty } from 'lodash-es';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';


@Component({
    selector: 'app-icc-import-eligible-providers',
    templateUrl: './icc-import-eligible-providers.component.html',
    styleUrls: ['./icc-import-eligible-providers.component.scss'],
    imports: [ImportNavComponent, IccImportUploadComponent]
})
export class IccImportEligibleProvidersComponent {
  private eligibleProviderImportsService = inject(IccEligibleProviderImportsService);
  private router = inject(Router);

  errors: string[] = [];

  onUploadComplete({ clientId, name, upload }: ImportUploadResult) {
    this.eligibleProviderImportsService.create(clientId, name, upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/icc-claims/imports/eligible-providers/history']);
      },
      (error: HttpErrorResponse) => {
        this.errors = error.error.errors;
      }
    );
  }

  onUploadStart() {
    this.errors = [];
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
